<template>
  <v-container>
    <div class="row">
      <div v-if="this.$store.getters.isAdmin && !this.showAllMap" class="column" style="width: 20%;float: left;">
        <v-flex>
          <div>
            <v-layout>
              <v-flex xs12 sm10 offset-sm1>
                <v-text-field v-model="search" @keyup="searchFilter" append-icon="search" label="Buscar" single-line
                  hide-details></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <div style="overflow-y: scroll; height:85vh; padding-left: 20px;">
          <v-draggable-treeview group="test" v-model="items">
            <template v-slot:prepend="{ item }"
              :style="{ backgroundColor: item.id === selectedItemId ? 'lightgray' : '' }">
              <div @click="searchData(item.id)"
                :style="{ backgroundColor: item.id === selectedItemId ? 'lightgray' : '' }">
                <img v-if="item.authority=='ROLE_ADMIN'" src="../../assets/logo.png" width="30px">
                <img v-if="item.authority=='ROLE_USER'"
                  :src="(item.gender=='Femenino')?'https://imagenes-tugps.s3.amazonaws.com/female1.png':'https://imagenes-tugps.s3.amazonaws.com/male1.png'"
                  width="30px">
                <img v-if="item.authority=='ROLE_FLOTA'"
                  :src="(item.gender=='Femenino')?'https://avatars-tupgps.s3.amazonaws.com/personas/femaleFlota.png':'https://avatars-tupgps.s3.amazonaws.com/personas/maleFlota.png'"
                  width="30px">
                <img v-if="item.authority=='ROLE_INSTALADOR'"
                  src="https://imagenes-tugps.s3.amazonaws.com/INSTALADOR.png" width="30px">
                <img v-if="item.authority=='ROLE_CHOFER'" src="https://imagenes-tugps.s3.amazonaws.com/CHOFER.png"
                  width="30px">
              </div>
              <a @click="searchData(item.id)" class="text-tree-view"
                :style="{ backgroundColor: item.id === selectedItemId ? 'lightgray' : '' }">{{ item.name }}</a>
            </template>
          </v-draggable-treeview>
        </div>
      </div>
      <div v-if="$store.getters.isAdmin && !this.showAllMap" class="column" style="width: 20%;float: left;">
        <div v-if="expires_in!=-1" style="background-color: #f3aa32">
          <h4>Tiempo actualización en: {{ expires_in }}</h4>
        </div>
        <br>
        <v-flex>
          <div>
            <v-layout>
              <v-flex xs12 sm10 offset-sm1>
                <v-text-field v-model="search2" append-icon="search" label="Buscar" single-line
                  hide-details></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <div style="overflow-y: scroll; height:80vh;">
          <v-checkbox :v-if="devices.length>0" v-model="selectAll" @change="toggleSelectAll"
            label="Seleccionar Todos"></v-checkbox>
          <v-data-table :headers="headers2" :items="devices" :search="search2" hide-actions class="elevation-1">
            <template slot="items" slot-scope="props">
              <td class="text-xs-left" style="min-width:90px; padding-inline: 5px !important;">
                <v-checkbox style="display: inline-block;" v-model="props.item.selected"
                  @change="createInterval(props.item)" hide-details></v-checkbox>
                <div style="float: right; max-width: 40px"><img :src="props.item.image" width="40px"></div>
              </td>
              <td class="text-xs-left" style="padding-inline: 5px !important;">
                <div class="status-row">
                  <span>{{ props.item.name.toUpperCase() }}</span>
                  <div class="status-container" v-if="props.item.marker && props.item.selected">
                    <div class="status" v-if="(!props.item.marker.offline && props.item.marker.status === 'rely') || (!props.item.marker.offline && props.item.marker.accStatus == '1' && props.item.marker.motion == '0')">
                      <span class="status-dot" style="background-color: orange;"></span>
                      <span style="color: orange;">Detenido Prendido</span>
                    </div>
                    <div class="status" v-else-if="!props.item.marker.offline && props.item.marker.accStatus == '1' && parseInt(props.item.marker.speed) > 0">
                      <span class="status-dot" style="background-color: #32CD32;"></span>
                      <span style="color: #32CD32;">Movimiento</span>
                    </div>
                    <div class="status" v-else-if="!props.item.marker.offline && props.item.marker.accStatus == '0'">
                      <span class="status-dot" style="background-color: red;"></span>
                      <span style="color: red;">Detenido</span>
                    </div>
                    <div class="status" v-else-if="props.item.marker.offline">
                      <span class="status-dot" style="background-color: gray;"></span>
                      <span style="color: gray;">Fuera de Línea</span>
                    </div>
                  </div>
                </div>
              </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              No se han encontrado resultados para "{{ search }}".
            </v-alert>
          </v-data-table>
        </div>


      </div>
      <div v-if="!this.$store.getters.isAdmin && !this.showAllMap" class="column" style="width: 20%;float: left;">
        <br>

        <div style="overflow-y: scroll; height:85vh;">
          <v-flex>
            <div>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field v-model="search2" append-icon="search" label="Buscar" single-line
                    hide-details></v-text-field>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <v-draggable-treeview style="font-size: 13px !important;" group="test" v-model="items">
            <template v-slot:prepend="{ item }">
              <div @click="searchData(item.id)">
                <img v-if="item.authority=='ROLE_ADMIN'" src="../../assets/logo.png" width="30px">
                <img v-if="item.authority=='ROLE_USER'"
                  :src="(item.gender=='Femenino')?'https://imagenes-tugps.s3.amazonaws.com/female1.png':'https://imagenes-tugps.s3.amazonaws.com/male1.png'"
                  width="30px">
                <img v-if="item.authority=='ROLE_FLOTA'"
                  :src="(item.gender=='Femenino')?'https://avatars-tupgps.s3.amazonaws.com/personas/femaleFlota.png':'https://avatars-tupgps.s3.amazonaws.com/personas/maleFlota.png'"
                  width="30px">
                <img v-if="item.authority=='ROLE_INSTALADOR'"
                  src="https://imagenes-tugps.s3.amazonaws.com/INSTALADOR.png" width="30px">
                <img v-if="item.authority=='ROLE_CHOFER'" src="https://imagenes-tugps.s3.amazonaws.com/CHOFER.png"
                  width="30px">
              </div>
              <a @click="searchData(item.id)" class="text-tree-view">{{ item.name }}</a>
            </template>
          </v-draggable-treeview>
        </div>
        <div v-if="this.expires_in!=-1" align="center" style="background-color: #f3aa32">
          <h4>Tiempo actualización en: {{ this.expires_in }}</h4>
        </div>

      </div>
      <div v-if="!this.$store.getters.isAdmin && !this.showAllMap" class="column" style="width: 20%;float: left;">
        <div v-if="expires_in!=-1" style="background-color: #f3aa32">
          <h4>Tiempo actualización en: {{ expires_in }}</h4>
        </div>
        <br>
        <v-flex>
          <div>
            <v-layout>
              <v-flex xs12 sm10 offset-sm1>
                <v-text-field v-model="search2" append-icon="search" label="Buscar" single-line
                  hide-details></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <v-checkbox :v-if="devices.length>0" v-model="selectAll" @change="toggleSelectAll"
          label="Seleccionar Todos"></v-checkbox>
        <div style="overflow-y: scroll; height:80vh;">
          <v-data-table :headers="headers2" :items="devices" :search="search2" hide-actions class="elevation-1">
            <template slot="items" slot-scope="props">
              <td class="text-xs-left" style="min-width:90px; padding-inline: 5px !important;">
                <v-checkbox style="display: inline-block;" class="no-ripple-checkbox" v-model="props.item.selected" v-if="$store.getters.isActiveDevice(props.item)"
                  @change="createInterval(props.item)" color="blue" hide-details></v-checkbox>
                <div style="float: right; max-width: 40px"><img :src="props.item.image" width="40px"></div>
              </td>
              <td class="text-xs-left" style="padding-inline: 5px !important;">
                <div class="status-row">
                 
                  <span  v-if="!$store.getters.isActiveDevice(props.item)">{{ props.item.name.toUpperCase() }} / Inactivo </span>
                  <span v-else>{{ props.item.name.toUpperCase() }}</span>
                  <div class="status-container" v-if="props.item.marker && props.item.selected && $store.getters.isActiveDevice(props.item)">
                    <div class="status" v-if="(!props.item.marker.offline && props.item.marker.status === 'rely') || (!props.item.marker.offline && props.item.marker.accStatus == '1' && props.item.marker.motion == '0')">
                      <span class="status-dot" style="background-color: orange;"></span>
                      <span style="color: orange;">Detenido Prendido</span>
                    </div>
                    <div class="status" v-else-if="!props.item.marker.offline && props.item.marker.accStatus == '1' && parseInt(props.item.marker.speed) > 0">
                      <span class="status-dot" style="background-color: #32CD32;"></span>
                      <span style="color: #32CD32;">Movimiento</span>
                    </div>
                    <div class="status" v-else-if="!props.item.marker.offline && props.item.marker.accStatus == '0'">
                      <span class="status-dot" style="background-color: red;"></span>
                      <span style="color: red;">Detenido</span>
                    </div>
                    <div class="status" v-else-if="props.item.marker.offline">
                      <span class="status-dot" style="background-color: gray;"></span>
                      <span style="color: gray;">Fuera de Línea</span>
                    </div>
                  </div>
                </div>
              </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              No se han encontrado resultados para "{{ search }}".
            </v-alert>
          </v-data-table>
        </div>


      </div>

      <div class="column" style="width: 55px;float: left;" align="center">
        <button @click="viewType='MAPA';expires_in=0" class="box-icon">
          <img src="https://dunedingoescarting.com/wp-content/uploads/2019/09/map-1272165_960_720.png" width="40px"
            class="icon" />
        </button>
        <br>
        <button @click="viewType='TRÁFICO';expires_in=0" class="box-icon">
          <img
            src="https://e7.pngegg.com/pngimages/520/93/png-clipart-computer-icons-traffic-light-symbol-traffic-light-driving-traffic-sign.png"
            width="40px" class="icon" />
        </button>
        <br>
        <button @click="viewType='TRÁFICO'; viewType='VISTA DE CALLE';expires_in=0" class="box-icon"
          :disabled="device.id!=''">
          <img
            src="https://media.istockphoto.com/vectors/webcam-icon-vector-id1192990797?k=6&m=1192990797&s=170667a&w=0&h=f65eNHZKE7g39vL4BBOIYKNgu15MiGWgrIoju4-m9xE="
            width="35px" class="icon" />
        </button>
        <button @click="changeRuler"  class="box-icon">
          <img src="https://img.favpng.com/20/18/3/computer-icons-drawing-ruler-icon-design-png-favpng-e2r7mgDwaNLRZwAnnf5VhQgFV.jpg" width="35px" class="icon"/>
        </button>
        <button @click="showAllMap=true" class="box-icon" v-if="!showAllMap">
          < </button>
            <button @click="showAllMap=false" class="box-icon" v-if="showAllMap">
              >
            </button>
            <br>

      </div>
      <div v-if="viewType=='MAPA'" class="column"
        :style="{width: showAllMap ? '95%' : '55%', height: '100%', float: 'left'}">
        <GmapMap ref="gmap" :center="this.mapView" :zoom="14" map-type-id="roadmap" :options="{
                      scaleControl: true,
                      mapTypeControl: true,
                      zoomControl: true,
                      scrollwheel: true,
                      keyboardShortcuts: false,
                      gestureHandling: 'greedy'
                    }" style="width: 100%; height: 85vh" @click="mark">
          <GmapMarker :key="index" v-for="(m, index) in markers" :id="m.position.imei" :position="m.position"
            :clickable="true" @click="selectMarker(m)" :icon="m.icon" />
          <gmap-info-window :key="`info-${m.imei}-${m.name}-${m.status}}`"
            v-for="(m, index) in markers" :position="m.position" :options="{
            pixelOffset: {
              width: 0,
              height: -50
            },
            disableAutoPan: true
          }">
            <div>{{ m.name }}</div>
          </gmap-info-window>
          <gmap-polyline v-if="measures" :key="m.position.lng" v-for="(m, index2) in measures" :path="m.position"
            :options="{ strokeColor:m.colorLine}" />
          <GmapMarker v-if="measures" :key="m.position.lat" v-for="(m) in measures" :position="m.position[1]" :clickable="true"
            :options="{
                      label: m.distance,
                      disableAutoPan: true
                    }" :icon="m.icon" />
        </GmapMap>
      </div>
    </div>
    <div v-if="viewType=='TRÁFICO'" class="column"
      :style="{width: showAllMap ? '95%' : '55%', height: '100%', float: 'left'}">
      <GmapMap ref="gmapTraffic" :center="this.mapView" :zoom="14" map-type-id="roadmap" :options="{
                      scaleControl: true,
                      mapTypeControl: true,
                      zoomControl: true,
                      scrollwheel: true,
                      gestureHandling: 'greedy',
                    }" style="width: 100%; height: 85vh" @click="mark">
        <GmapMarker :key="index4" v-for="(m, index4) in markers" :position="m.position" :clickable="true"
          @click="selectMarker(m)" :icon="m.icon" />
        <GmapMarker v-if="measures" :key="index5" v-for="(m, index5) in measures" :position="m.position[1]"
          :clickable="true" :options="{
                      label: m.distance,
                      disableAutoPan: true
                    }" />
      </GmapMap>

    </div>

    <div v-if="viewType=='VISTA DE CALLE'" id="map-canvas" style="width: 800px;height: 85vh;"></div>

    <v-dialog v-if="dialogInfo==true" v-model="dialogInfo" width="500px" transition="dialog-bottom-transition"
      scrollable>
      <v-card tile>
        <v-toolbar card dark color="nav_background_color">
          <v-btn icon dark @click.native="dialogInfo = false;selectedImei = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Información Dispositivo</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <div align="center">
              <div v-if="(!this.marker.offline && this.marker.status==='rely') || (!this.marker.offline && this.marker.accStatus=='1' && this.marker.motion=='0')"
                style="border: 2px solid yellow; width: 100px; height: 100px">
                <div style="padding-top: 15px" align="center">
                  <span>{{ '0' }} km/h</span>
                  <span style="color: yellow">Detenido Prendido</span>
                </div>
              </div>
              <div v-else-if="!this.marker.offline && this.marker.accStatus=='1' && parseInt(this.marker.speed)>0"
                style="border: 2px solid greenyellow; width: 100px; height: 100px">
                <div style="padding-top: 15px" align="center">
                  <span>{{ this.marker.accStatus == '1' ? (this.marker.speed*1.852).toFixed(0) : '0' }} km/h</span>
                  <span style="color: greenyellow">Movimiento</span>
                </div>
              </div>
              <div v-else-if="!this.marker.offline && this.marker.accStatus=='0'"
                style="border: 2px solid red; width: 100px; height: 100px">
                <div style="padding-top: 15px" align="center">
                  <span>{{ this.marker.accStatus == '1' ? (this.marker.speed*1.852).toFixed(0) : '0' }} km/h</span>
                  <span style="color: red">Detenido</span>
                </div>
              </div>
              <div v-else-if="this.marker.offline" style="border: 2px solid gray; width: 100px; height: 100px">
                <div style="padding-top: 15px" align="center">
                  <span></span>
                  <span style="color: gray">Fuera de Línea</span>
                </div>
              </div>


              <div v-if="!this.marker.offline && this.marker.status==='rely'  || (!this.marker.offline && this.marker.accStatus=='1' && this.marker.motion=='0')">
                {{ "Tiempo detenido prendido: " }}{{ this.$store.getters.msToTime(this.marker.timeRely) }}
              </div>
              <div v-else-if="!this.marker.offline && this.marker.accStatus=='0'">
                {{ "Tiempo detenido: " }}{{ this.$store.getters.msToTime(this.marker.timeStop) }}
              </div>
              <div v-else-if="this.marker.offline">
                {{ "Tiempo fuera de línea: " }}{{ this.marker.timeOffline ? this.$store.getters.msToTime(this.marker.timeOffline):"N/A"
                }}
              </div>

              <img :src="this.marker.icon.url2" width="15%">
            </div>
            <v-layout>
              <v-flex xs12 sm10 offset-sm1>
                <strong>Nombre: </strong>{{this.marker.name}}<br>
                <strong>Modelo: </strong>{{this.marker.model}}<br>
                <v-flex v-if="!this.marker.offline">
                  <strong>Velocidad:
                  </strong>{{this.marker.accStatus=='1'?(this.marker.speed*1.852).toFixed(0)+'Km/h':'0'}}<br>
                  <strong>Motor: </strong>{{this.marker.accStatus=='1'?'ENCENDIDO':'APAGADO'}}<br>
                </v-flex>
                <strong>Odómetro: </strong>{{parseInt(this.marker.odometer)}} Km<br>
                <strong>Posición: </strong><a
                  :href="'https://www.google.com/maps/?q='+this.marker.position.lat+','+this.marker.position.lng"
                  target="_blank">{{ this.marker.position.lat.toFixed(5) }},{{ this.marker.position.lng.toFixed(5)
                  }}</a>
                <v-flex v-if="$store.getters.isAdmin">
                  <strong>Imei: </strong>{{this.marker.imei}}<br>
                  <strong>Sim: </strong>{{this.marker.sim}}<br>
                </v-flex>
                <p v-if="this.direction"><strong>Dirección:</strong> {{this.direction}}</p>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex class="text-xs-center" v-if="!$store.getters.isChofer">
                <v-btn @click="dialogBlock = true" large color="primary">Bloquear/Desbloquear</v-btn>
                <!--                <v-btn @click="dialogInfo = false" large color="primary">Acciones</v-btn>-->
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogBlock==true" v-model="dialogBlock" max-width="500px">
      <v-toolbar card dark color="nav_background_color">
        <v-btn icon dark @click.native="dialogBlock = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Información Dispositivo</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card tile>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
              <h2>Al presionar el boton ejecutarás el comando</h2>
            </v-layout>
            <v-layout>
              <v-flex class="text-xs-center">
                <div>
                  <v-btn :disabled="!valid" @click="sendDeviceActionBlock()" large color="primary">Bloquear
                  </v-btn>
                  <v-btn :disabled="!valid" @click="sendDeviceActionUnBlock()" large color="primary">Desbloquear
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogError" max-width="500px">
      <v-card>
        <v-card-title>
          <span>No se ha podido obtener la geolocalización del dispositivo</span>
        </v-card-title>
        <v-card-actions>
          <v-btn color="primary" text @click="dialogError = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Device from '../../model/Device';
import $ from "jquery";


export default {
  data() {
    return {
      headers: [
        { text: 'Cuenta', value: 'completeName' },
        { text: 'Rol', value: 'role' },

      ],
      items: [],
      itemsOriginal: [],
      search: '',
      search2: '',
      valid: false,
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,
      dialogInfo: false,
      markers: [],
      editedIndex: -1,
      device: new Device(),
      date: "",
      menu: false,
      deviceObject: {id: "", value: "", date: new Date()},
      singleSelect: false,
      active: 0,
      dialogBlock: false,
      dialogError: false,
      dialogGeo: false,
      devices: [],
      infoOpened: false,
      infoOptions: null,
      infoPosition: null,
      infoContent: null,
      marker: null,
      countTimesCall: 0,
      headers2: [
        {text: '', value: '', width:'20%'},
        {text: 'Nombre del equipo', value: 'name'},
      ],
      mapView: {lat: -0.190029, lng: -78.482114},
      expires_in: -1,
      selectedInMap: "",
      imageDevice: "",
      directionDevice: 0,
      direction: "",
      typesView: ["MAPA", "VISTA DE CALLE", "TRÁFICO"],
      viewType: "MAPA",
      ruler: false,
      userList:[],
      itemsSelected:[],
      measures:[],
      measureIndex:0,
      measureMarker:null,
      distance:0,
      timeStop:0,
      level: 0,
      intervalList: [],
      selectedImei: "",
      intervalCssNumber: 0,
      selectedItemId: null,
      selectAll: false,
      showAllMap: false,
      usersToSearch:[],
      };
  },
  watch:{
  },


  methods: {
    cleanData() {
      this.$refs.form.reset();
      this.device = new Device();
      this.valid = false;
      this.dialog = false;
    },

    editItem(item) {
      this.editedIndex = this.devices.indexOf(item);
      this.device = Object.assign({}, item);
      this.dialog = true;
    },
    toggleSelectAll() {
      this.devices.forEach(device => {
        device.selected = this.selectAll;
        if (this.selectAll) {
          let deviceToAdd = this.devices.indexOf(device)
          if(this.$store.getters.isActiveDevice(device)){
            this.itemsSelected.push(deviceToAdd);
            this.createInterval(deviceToAdd)
          }
        } else {
          this.itemsSelected = [];
          this.markers = [];
        }
      });
    },
    selectedItem(item) {
      this.singleSelect = false
      this.editedIndex = this.devices.indexOf(item);
      for (let i = 0; i < this.devices.length; i++) {
        this.devices[i].selected = false
      }
      this.devices[this.editedIndex].selected = true
      this.device = this.devices[this.editedIndex]
      this.singleSelect = true
    },
    sendDeviceActionBlock() {
        this.$store.dispatch('sendDeviceActionTraccar', {
          "deviceId": this.device.idTraccar,
          "description": "version",
          "type": "custom",
          "attributes": {
            "data": "Relay,1#"
          }
        }).then(response => {
          this.device.lastAction = 'Bloqueado'
          this.saveData(false)
          this.dialogBlock = false
        })
    },
    sendDeviceActionUnBlock() {
      this.$store.dispatch('sendDeviceActionTraccar', {
              "deviceId": this.device.idTraccar,
              "description": "version",
              "type": "custom",
              "attributes": {
                "data": "Relay,0#"
              }
            }
        ).then(response => {
          this.device.lastAction = 'Desbloqueado'
          this.saveData(false)
          this.dialogBlock = false
        })
    },
    saveData(reload) {
        this.$store.dispatch('getOneUser', this.device.user.login).then(
            responseUser => {
              if(this.$store.state.deviceUser.firstName!=null){
                this.device.userName = this.$store.state.deviceUser.firstName + " "+this.$store.state.deviceUser.lastName
              }
              this.deviceObject.value = JSON.stringify(this.device)
              this.deviceObject.id = this.device.id
              if(responseUser.data){
                this.deviceObject.user = responseUser.data
              }

              if (this.device.id != null && this.device.id != "") {
                this.$store.dispatch('updateDevice', this.deviceObject).then(
                    response => {
                      if(reload){
                        this.reload();
                      }
                    },
                    error => {
                      this.$store.state.progress = false;
                      this.$store.state.dialogError = true;
                    }
                );
              } else {
                this.deviceObject.date = new Date()
                this.deviceObject.user = responseUser.data
                this.deviceObject.user.clientData = ""
                this.$store.dispatch('addDevice', this.deviceObject).then(
                    response => {
                      if(reload){
                        this.reload();
                      }
                    },
                    error => {
                      this.$store.state.progress = false;
                      this.$store.state.dialogError = true;
                    }
                );
              }
              this.dialog = false;
            },
            error => {
              this.$store.state.progress = false;
              this.$store.state.dialogError = true;
            }
        );
    },
    createInterval(item) {
      this.editedIndex = this.devices.indexOf(item);
      if(item.selected){
        this.itemsSelected.push(this.editedIndex)
        this.countTimesCall=0
      }else{
        for (let i = 0; i < this.itemsSelected.length; i++) {
          if(this.itemsSelected[i]===this.editedIndex){
            this.itemsSelected.splice(i,1)
          }
        }
      }
      this.clearIntervalCustome()
      this.intervalCssNumber = setInterval(() => {
        if (this.markers.length > 0) {
          for (const marker of this.markers) {
            const $element = $('img[src*="' + marker.image + '"]').parent();
            $element.hide(); // Hide the element
            $element.css('transform', 'rotate(' + marker.directionDevice + 'deg)'); // Rotate the element
            $element.show(); // Show the element again
          }
        }
      }, 1);
      this.markers = []
      if(this.itemsSelected.length==0){
        this.expires_in = -1
        return
      }
      this.expires_in = 0
      this.intervalList.push(setInterval(() => {
      if (this.expires_in === 0) {
        this.expires_in = 10;
        this.markers = [];
        for (let i = this.itemsSelected.length; i > 0; i--) {
          this.selectedItemMap(this.itemsSelected[i - 1]);
        }
      } else {
        this.expires_in = this.expires_in - 1;
      }
    }, 1000))
    },


    selectedItemMap(itemIndex) {
      this.singleSelect = false
      this.$store.dispatch('getDevicesLocationTraccar', this.devices[itemIndex].idTraccar).then(response => {
        if (response && response.data && response.data.result.length > 0) {

            let queryParam = "deviceId="+this.devices[itemIndex].idTraccar+"&from="+this.dateStart()+"&"+"to="+this.dateEnd()
            this.timeStop = 0;

            // Get the latest events
            this.$store.dispatch('getDevicesLocationTraccarAlarm', queryParam).then(responseEvent => {
              let image = this.devices[itemIndex].image
              this.accStatus = response.data.result[0].accStatus;
              let motion = response.data.result[0].motion;
              if (response.data.result[0].status === 'rely' || (this.accStatus == '1' && motion == '0')) {
                image = image.replace("1.", "A.");
              } else if (this.accStatus == '1' && parseInt(response.data.result[0].speed) > 0) {
                image = image.replace("1.", "V.");
              } else if (this.accStatus == '0') {
                image = image.replace("1.", "R.");
              } else {
                image = image.replace("1.", "G.");
              }
              image = image.replace("nuevos/", 1+"/nuevos/");
              let now = new Date();
              let deviceTime = new Date(response.data.result[0].deviceTime);
              let minutesForOffline = 7 * 60 * 1000; // 10 minutes
              // If the latest position device time is grater than minutesForOffline then
              // assing time between deviceTime and now to timeStop
              let timeStop = {}
              let offline = false
              let timeDifference = now - deviceTime;
              
              let timeOffline = timeDifference;
              let minutesOffline = timeDifference / 1000 / 60;
              //************************IMPORTANT TO TRACE******************************
              //console.log('Time Difference (minutes):', minutesOffline);

              if (timeDifference > minutesForOffline) {
                image = image.replace("1.", "G.");
                image = image.replace("V.", "G.");
                image = image.replace("R.", "G.");
                image = image.replace("A.", "G.");
                timeStop = (deviceTime.getTime() - (now.getTime())) * -1;
                offline = true;
              } else {
                offline = false;
              }

              // If device is stopped then get timeStop from event response when type is ignitionOff
              if (!offline) {
                for (let i = 0; i < responseEvent.data.length; i++) {
                  if (responseEvent.data[i].type == "ignitionOff") {
                    deviceTime = new Date(responseEvent.data[i].eventTime);
                    timeStop = (now.getTime() - deviceTime.getTime());
                    break;
                  }
                }
              }

                this.changeType(response)
                let respPosition = {
                  position: {
                    lat: response.data.result[0].lat,
                    lng: response.data.result[0].lng,
                    imei: this.devices[itemIndex].imei
                  },
                  icon: {
                    url2: this.devices[itemIndex].image,
                    url: image,
                    scaledSize: { width: 55, height: 55, f: 'px', b: 'px' },
                  },
                  odometer: response.data.result[0].odometer,
                  imei: this.devices[itemIndex].imei,
                  name: this.devices[itemIndex].name,
                  sim: this.devices[itemIndex].sim,
                  model: this.devices[itemIndex].model,
                  accStatus: this.accStatus,
                  motion:motion,
                  speed: response.data.result[0].speed,
                  blocked: this.devices[itemIndex].lastAction == 'Bloquear' ? true : false,
                  image: image,
                  //direction: responseGetStreet,
                  directionDevice: response.data.result[0].direction,
                  timeOffline: timeOffline,
                  timeStop: timeStop,
                  offline: offline,
                  status: response.data.result[0].status,
                  idTraccar: this.devices[itemIndex].idTraccar
                }
                if (this.countTimesCall == 0) {
                  this.mapView = {
                    lat: response.data.result[0].lat,
                    lng: response.data.result[0].lng,
                  }
                }
                this.countTimesCall++

              if ((response.data.result[0].status === "rely" || (this.accStatus == '1' && motion == '0')) && (this.dialogInfo == true && this.selectedImei === this.devices[itemIndex].imei)) {
                let queryParam = "deviceId=" + this.devices[itemIndex].idTraccar
                this.$store.dispatch('getDevicesLocationTraccarLastRely', queryParam).then(responseReport => {
                  if (responseReport == null || responseReport === undefined || responseReport.data == null) {
                    return 0
                  }
                  let lastTime = responseReport.data.result[0]
                  //console.log(lastTime)
                  let gpsTime = new Date(lastTime.deviceTime);
                  //console.log(gpsTime)
                  let timeDifferenceRely = now - gpsTime;
                  //console.log(timeDifferenceRely)
                  this.marker.timeRely = timeDifferenceRely
                })
              }
                this.markers.push(respPosition)
                if (this.selectedImei === respPosition.imei) {
                  this.marker = respPosition
                }
              
              this.devices.forEach(device => {
                const marker = this.markers.find(marker => marker.imei === device.imei);
                if (marker) {
                  device.marker = marker;
                }
              });
   
          })
        }
      })
      this.singleSelect = true
    },
    

    changeType(response){
      if(this.viewType=='MAPA'){


      }else if(this.viewType=='VISTA DE CALLE'){
        var fenway = new google.maps.LatLng(response.data.result[0].lat,response.data.result[0].lng);

        var panoOptions = {
          position: fenway,
          addressControlOptions: {
            position: google.maps.ControlPosition.BOTTOM_CENTER
          },
          linksControl: false,
          panControl: false,
          zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL
          },
          enableCloseButton: false
        };

        var panorama = new google.maps.StreetViewPanorama(
            document.getElementById('map-canvas'), panoOptions);

        var cafe = new google.maps.LatLng(response.data.result[0].lat,response.data.result[0].lng);

        var cafeMarker = new google.maps.Marker({
          position: cafe,
          map: panorama,
          title: 'Cafe'
        });
        var heading = google.maps.geometry.spherical.computeHeading(panorama.getPosition(),cafe);

        panorama.setPov({
          heading: heading,
          pitch: 0,
          zoom: 1
        });
      }else if(this.viewType=='TRÁFICO'){
        const trafficLayer = new google.maps.TrafficLayer();
        trafficLayer.setMap(this.$refs.gmapTraffic.$mapObject);
      }
    },
    selectMarker(item) {
      let devicesFound = this.devices.filter(dev => dev.imei===item.imei)
      if(devicesFound[0]){
        this.device = devicesFound[0];
      }
      this.selectedImei = item.imei
      this.marker = item
      this.dialogInfo=true
        this.$store.dispatch('getStreetFromCoordinates', {
          lat: this.marker.position.lat,
          lng: this.marker.position.lng,
          imei: item.imei
        }).then(responseGetStreet => {
          this.direction = responseGetStreet;
        })
      let queryParam = "deviceId=" + item.idTraccar
      let now = new Date();
      this.$store.dispatch('getDevicesLocationTraccarLastRely', queryParam).then(responseReport => {
        if (responseReport == null || responseReport === undefined || responseReport.data == null) {
          return 0
        }
        let lastTime = responseReport.data.result[0]
        //console.log(lastTime)
        let gpsTime = new Date(lastTime.deviceTime);
        //console.log(gpsTime)
        let timeDifferenceRely = now - gpsTime;
        //console.log(timeDifferenceRely)
        this.marker.timeRely = timeDifferenceRely
      })
    },
    openBlockDialog() {
      this.dialogBlock = true
    },
    searchData(login) {
      this.usersToSearch = [];
      this.selectedItemId = login;
      this.selectAll = false;
      this.deleteInterval()
      this.$store.dispatch('getRelatedDevicesByUserLoginFull', login).then(response => {
        this.devices = []
        this.geoFences = []
        this.markers = []
        this.expires_in = -1
        for (let i = 0; i < response.data.length; i++) {
          let object = JSON.parse(response.data[i].value)
          object.id = response.data[i].id
          object.selected = false
          object.user = response.data[i].user
          this.devices.push(object)
        }
        if(this.level == 0){
          this.level = 1
        }
        this.devices.sort((a, b) => (a.userName > b.userName) ? 1 : -1)
        this.$store.dispatch('getOneUser', login).then(responseData => {
          if(responseData.data.clientData!=null){
            let clientData= JSON.parse(responseData.data.clientData)
            if(clientData.devices.length>0){
              // El endpoint -full ya trae los equipos embebidos que existen en user_device (por idTraccar).
              // Aqui solo agregamos los que NO vinieron (ej. sin idTraccar o sin fila en user_device),
              // deduplicando por idTraccar (y por id) para no duplicar.
              const existingTraccar = new Set(
                this.devices.map(d => (d.idTraccar != null ? String(d.idTraccar) : null)).filter(x => x)
              )
              const existingIds = new Set(this.devices.map(d => d.id))
              for (const clientDatum of clientData.devices) {
                if(clientDatum!=null) {
                  const t = clientDatum.idTraccar != null ? String(clientDatum.idTraccar) : null
                  if ((t && existingTraccar.has(t)) || existingIds.has(clientDatum.id)) {
                    continue
                  }
                  this.devices.push(clientDatum)
                }
              }
            }
          }
        });
      })
    },


    processUserChildren(userChildren) {
      if (userChildren && userChildren.length > 0) {
        for (const user of userChildren) {
           this.usersToSearch.push(user)
          // Recursive call to process children of the current user
          if (user!=null && user.userChildren!=null && user.userChildren.length > 0) {
            this.processUserChildren(user.userChildren);
          }
        }
      }
    },

    searchFilter(){
      let result = this.itemsOriginal
      this.items=result
      if (!this.search || this.search=='')
        return result

      const filterValue = this.search.toLowerCase()

      const filter = event =>
          event.name.toLowerCase().includes(filterValue)

      return this.items=result.filter(filter)
    },

    reload() {
      //Busca si es admin
      if(this.$store.getters.isAdmin) {
        this.userList = []
        this.$store.dispatch('getUsersForAdmin').then(response => {
          let childrenToSplice = []
            for (const user of response.data) {
              user.completeName = user.firstName + " " + user.lastName
              user.clientData = JSON.parse(user.clientData)
              let item = { id: user.login, name: user.completeName, children: [], authority: user.authorities[0], gender:"Masculino"}   

              if(user.clientData != null && user.clientData.genero != null){
                item.gender = user.clientData.genero
              }

              if(user.clientData != null && user.clientData.devices != null){
                user.children = user.clientData.devices
              }
              if(user.clientData != null && user.clientData.userChildren != null){
                for (const child of user.clientData.userChildren) {
                  if(child != null){
                    try{
                      let itemChild = { id: child.login, name: child.firstName + " " + child.lastName, authority: "ROLE_USER", gender: child.clientData.genero, group: "test", open: true }
                      item.children.push(itemChild)
                      childrenToSplice.push(itemChild)

                    }catch(e){
                      //console.log(child.clientData)
                    }
                  }
                }
              }

              this.userList.push(user)
              this.items.push(item)
            }
          // for(const child of childrenToSplice){
          //   let index = this.items.findIndex(item => item.id === child.id);
          //   this.items.splice(index, 1);
          // }
          this.itemsOriginal= this.items
          this.items.sort((a, b) => (a.name > b.name) ? 1 : -1)

        })
        //Busca flota/Chofer
      }else {
        this.$store.dispatch('getOneUser', this.$store.state.idUser).then(response => {
          let user = response.data
          let childrenToSplice = []
          try{
            user.completeName = user.firstName + " " + user.lastName
            user.clientData = JSON.parse(user.clientData)
            let item = { id: user.login, name: user.completeName, children: [], authority: user.authorities[0], gender:"Masculino"}

            if(user.clientData != null && user.clientData.genero != null){
              item.gender = user.clientData.genero
            }
            if(user.clientData != null && user.clientData.devices != null){
              user.children = user.clientData.devices
            }
            if(user.clientData != null && user.clientData.userChildren != null){
              for (const child of user.clientData.userChildren) {
                try{
                      let itemChild = { id: child.login, name: child.firstName + " " + child.lastName, authority: "ROLE_USER", gender:child.clientData.genero }
                      item.children.push(itemChild)
                      //childrenToSplice.push(itemChild)
                    }catch(e){
                      //console.log("No hay datos hijo")
                    }
              }
            }
            this.userList.push(user)
            this.items.push(item)
          }catch (e){
            //console.log("No hay datos de dispositivos")
          }
          this.itemsOriginal= this.items
          this.items.sort((a, b) => (a.name > b.name) ? 1 : -1)
        });
      //Busca user
      }

      this.viewType= "MAPA"
    },
    mark(event) {
      if(!this.ruler){
        return
      }
      if(this.measureIndex==0){
        this.measures.push({
          id:this.measureIndex,
          position: [{
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
          }, {
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
          }], colorLine: '#000', distance:'0',
              icon: {
                url: 'https://www.clipartmax.com/png/full/17-170052_clipart-info-location-pin-icon-white.png',
                scaledSize: {width: 55, height: 55, f: 'px', b: 'px'},
              }
        }
        )
      }else{
        this.measures.push({
          id:this.measureIndex,
          position: [{
            lat: this.measures[this.measureIndex-1].position[1].lat,
            lng: this.measures[this.measureIndex-1].position[1].lng
          }, {
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
          }], colorLine: '#000',
          distance: (Number(this.measures[this.measureIndex - 1].distance) + this.haversine_distance({
                position: {
                  lat: this.measures[this.measureIndex - 1].position[1].lat,
                  lng: this.measures[this.measureIndex - 1].position[1].lng
                }
              },
              {
                position: {
                  lat: event.latLng.lat(),
                  lng: event.latLng.lng()
                }
              }
          )).toFixed(2).toString(),
          icon: {
            url: 'https://www.clipartmax.com/png/full/17-170052_clipart-info-location-pin-icon-white.png',
            scaledSize: {width: 55, height: 55, f: 'px', b: 'px'},
          }
        })
      }
      this.measureIndex++;

    },
    haversine_distance(mk1, mk2) {
      var R = 3958.8; // Radius of the Earth in miles
      var rlat1 = mk1.position.lat * (Math.PI/180); // Convert degrees to radians
      var rlat2 = mk2.position.lat * (Math.PI/180); // Convert degrees to radians
      var difflat = rlat2-rlat1; // Radian difference (latitudes)
      var difflon = (mk2.position.lng-mk1.position.lng) * (Math.PI/180); // Radian difference (longitudes)

      var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
      return d;
    },

    changeRuler(){
      if(this.ruler){
        this.ruler=false;
        this.measures=[]
        this.measureIndex=0
      }else{
        this.ruler=true;
      }
    },
    dateStart(){
      let date = new Date();
      // Five days ago
      date.setTime(date.getTime() - (5 * 24 * 60 * 60 * 1000)); // Convert hours to milliseconds - 60 minutes to an hour, 60 seconds to a minute, 1000 milliseconds to a second

      var day = date.getDate() + "";
      var month = date.getMonth()+1 + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours()+"";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";

      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },
    dateEnd(){
      let date = new Date();
      var day = date.getDate() + "";
      var month = date.getMonth()+1 + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours() + "";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";

      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },
    checkZero(data){
      if(data.toLocaleString().length == 1){
        data = "0" + data;
      }
      return data;
    },
    clearIntervalCustome() {
      if (this.intervalList)
        for (let i = 0; i <= this.intervalList.length; i++) {
          window.clearInterval(this.intervalList[i]); // Clear each interval
        }
    },
    deleteInterval() {
      clearInterval(this.$store.state.intervalMap)
      const highestIntervalId = window.setInterval(() => { }, 1000); // Get the highest interval ID
      for (let i = 0; i <= highestIntervalId; i++) {
        window.clearInterval(i); // Clear each interval
      }
    },
  },
  computed: {
    filter () {
      return this.caseSensitive
          ? (item, search, textKey) => item[textKey].indexOf(search) > -1
          : undefined
    }
  },
 
  created() {
    this.reload()
    this.clearIntervalCustome()
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.box-icon {
  transition: box-shadow .3s;
  width: 40px;
  height: 40px;
  border: 1px solid #ccc;
}
.no-ripple-checkbox .v-input--selection-controls__ripple,
.no-ripple-checkbox .v-ripple__container {
  display: none !important;
}
p {
  margin-bottom: 0 !important;
}
.selected-item {
  color: #f0f8ff;
  font-weight: bold;
}
.status-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.status-container {
  display: flex;
  align-items: center;
}
.status {
  display: flex;
  align-items: center;
}
.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/device/DeviceMap.vue